"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var footerDefaults = {
  wrapperBg: 'offwhite',
  footerContainerColorMobile: 'greydark',
  footerContainerColorDesktop: 'offblack',
  footerContactSectionColor: 'inherit',
  footerNavItemColor: 'greydark',
  footerNavItemColorHover: 'inherit',
  footerHtmlContainerColor: 'greydark',
  footerSocialBg: 'white',
  footerSocialBorderStyle: '0',
  footerSocialBorderColor: 'none',
  footerSocialFill: 'inherit',
  footerUtilityStyle: '0',
  footerUtilityColor: 'none',
  footerNavItemBg: 'inherit',
  footerSocialWrapperColor: 'inherit',
  copyrightFontSizeMobile: 'initial',
  utilityContainerFlexAlignMobile: 'center',
  utilityContainerFlexAlignDesktop: 'center',
  FooterHtmlContainerFontSizeMobile: 'inherit',
  FooterHtmlContainerFontSizeDesktop: 'inherit',
  footerSocialColor: 'inherit',
  copyrightColor: 'inherit'
};
var footer = {
  horizon: _objectSpread({}, footerDefaults),
  dcl: _objectSpread(_objectSpread({}, footerDefaults), {}, {
    footerSocialBg: 'offwhite',
    footerSocialBorderStyle: '1px solid',
    footerSocialBorderColor: 'greymid'
  }),
  money2020: _objectSpread(_objectSpread({}, footerDefaults), {}, {
    utilityContainerFlexAlignMobile: 'flex-start',
    wrapperBg: 'black',
    footerSocialBg: 'black',
    footerSocialBorderColor: 'black',
    footerSocialFill: 'white',
    footerSocialColor: 'white',
    copyrightColor: 'black',
    footerHtmlContainerColor: 'white',
    footerContainerColorMobile: 'white',
    footerContainerColorDesktop: 'white'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, footerDefaults), {}, {
    wrapperBg: 'primary',
    footerContainerColorMobile: 'white',
    footerContainerColorDesktop: 'white',
    footerContactSectionColor: 'white',
    footerNavItemColor: 'white',
    footerNavItemColorHover: 'white',
    footerHtmlContainerColor: 'white',
    footerSocialBg: 'primary',
    footerSocialBorderStyle: '2px solid',
    footerSocialBorderColor: 'greymid',
    footerSocialFill: 'white',
    footerUtilityStyle: '1px solid',
    footerUtilityColor: 'greymid',
    footerNavItemBg: 'primary',
    footerSocialWrapperColor: 'white',
    copyrightFontSizeMobile: '1.4rem',
    utilityContainerFlexAlignMobile: 'flex-start',
    FooterHtmlContainerFontSizeMobile: '1.4rem'
  })
};
var _default = footer;
exports.default = _default;